import type { TeamNameDisplayMode } from '@/state/useTeamNameDisplayStore';

export type LocationLabelSource = {
  commune?: string | null;
  wilaya?: string | null;
  commune_ar?: string | null;
  wilaya_ar?: string | null;
};

/**
 * "Commune, Wilaya" label for a location.
 * Arabic names are used only when the display mode is Arabic (falls back to Latin).
 * Returns "" when nothing is known.
 */
export function formatLocationLabel(
  location: LocationLabelSource | null | undefined,
  mode: TeamNameDisplayMode
): string {
  if (!location) return '';
  if (mode === 'arabic' && (location.commune_ar || location.wilaya_ar)) {
    return [location.commune_ar, location.wilaya_ar].filter(Boolean).join('، ');
  }
  return [location.commune, location.wilaya].filter(Boolean).join(', ');
}
